import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
export function ProcessSection() {
  const steps = [{
    number: '01',
    title: 'Discover & Define',
    description: 'We understand your goals, challenges, and opportunities to shape a clear direction.'
  }, {
    number: '02',
    title: 'Design & Build',
    description: 'We craft thoughtful, functional, and visually refined digital solutions.'
  }, {
    number: '03',
    title: 'Launch & Grow',
    description: 'We support optimization, iteration, and long-term performance.'
  }];
  return <Section id="process" background="default" data-id="element-146">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-147">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold font-heading text-[#0C0C0C] mb-6" data-id="element-148">
          How We Work
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg text-gray-600 leading-relaxed" data-id="element-149">
          Our approach is simple, collaborative, and designed to deliver
          meaningful outcomes.
        </motion.p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-150">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gray-200 -z-10" data-id="element-151" />

        {steps.map((step, index) => <motion.div key={step.number} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2
      }} className="bg-[#F8F8F6] pt-4 relative" data-id="element-152">
            <div className="w-16 h-16 rounded-full bg-white border-2 border-[#00316B] text-[#00316B] flex items-center justify-center text-xl font-bold font-heading mb-6 mx-auto md:mx-0 z-10 relative" data-id="element-153">
              {step.number}
            </div>
            <h3 className="text-xl font-bold font-heading text-[#0C0C0C] mb-3 text-center md:text-left" data-id="element-154">
              {step.title}
            </h3>
            <p className="text-gray-600 leading-relaxed text-center md:text-left" data-id="element-155">
              {step.description}
            </p>
          </motion.div>)}
      </div>
    </Section>;
}